var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "go-list-item",
      attrs: { "data-template": "ad", "data-size": "2x1" },
    },
    [
      _c("div", { staticClass: "go-card-ad" }, [
        _c("a", { staticClass: "go-card-link" }, [
          _vm.currentLanguage === "ko"
            ? _c("img", {
                attrs: { loading: "lazy", src: _vm.randomImageKo },
                on: { click: _vm.clickEventBanner },
              })
            : _c("img", {
                attrs: { loading: "lazy", src: _vm.randomImageEn },
                on: { click: _vm.clickEventBanner },
              }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }